import api from "@/lib/api";

export async function loginAuth(body) {
  const { data } = await api.post("/auth/login", body)
  return data
}